export * as collections from '@wix/auto_sdk_portfolio_collections/meta';
export * as portfolioSettings from '@wix/auto_sdk_portfolio_portfolio-settings/meta';
export * as projectItems from '@wix/auto_sdk_portfolio_project-items/meta';
export * as projects from '@wix/auto_sdk_portfolio_projects/meta';
export * as projectInCollections from '@wix/auto_sdk_portfolio_project-in-collections/meta';
export * as syncedProject from '@wix/auto_sdk_portfolio_synced-project/meta';
